import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fill", "label", "count"]
  static values = {
    remaining: Number,
    total: Number,
    percentage: Number
  }

  connect() {
    this.animate()
  }

  animate() {
    const pct = this.percentageValue
    const fill = this.fillTarget

    fill.style.width = "0%"
    requestAnimationFrame(() => {
      fill.style.transition = "width 0.8s cubic-bezier(0.4, 0, 0.2, 1)"
      fill.style.width = `${pct}%`
    })

    this.updateColor(pct)
  }

  updateColor(pct) {
    const fill = this.fillTarget
    fill.classList.remove("bg-red-500", "bg-amber-500", "bg-emerald-500")

    if (pct <= 20) {
      fill.classList.add("bg-red-500")
    } else if (pct <= 50) {
      fill.classList.add("bg-amber-500")
    } else {
      fill.classList.add("bg-emerald-500")
    }
  }

  remainingValueChanged() {
    this.animate()
  }
}